import {
  CounterElementWrapper,
  CounterLabel,
  CounterValue,
  Display,
  Separator,
} from "./InvoiceCounter.styles";
import { CircularProgress } from "@mui/material";

// Props for individual counter elements
interface CounterElementProps {
  label: string;
  value: number | string;
  warning: boolean;
  onClick?: () => void;
  isActive?: boolean;
}

// Props for the main InvoiceCounter component
interface InvoiceReportingCounterProps {
    invoice_count: number;
    stpRate: string;
    touchlessInvoiceRate: string;
    passedERPtouchlessRate: string;
    pendingInvoices: number;
    pendingOutOfSLA: number;
}

/**
 * Renders a single counter element with optional click functionality and styling.
 */
function InvoiceCounterElement(props: CounterElementProps) {
  return (
    <CounterElementWrapper>
      <CounterLabel
        style={{
          background: props.isActive ? "#3A3D9B" : "transparent",
          borderRadius: "4px",
          padding: "0",
        }}
      >
        {props.label}
      </CounterLabel>
      {props.onClick ? (
        <button
          onClick={() => {
            props.onClick?.();
          }}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
          }}
        >
          <CounterValue warning={props.warning}>{props.value}</CounterValue>
        </button>
      ) : (
        <CounterValue warning={props.warning}>{props.value}</CounterValue>
      )}
    </CounterElementWrapper>
  );
}


/**
 * Main component for rendering invoice counters and managing filter interactions.
 */
export default function InvoiceReportingCounter({
    invoice_count,
    stpRate,
    touchlessInvoiceRate,
    passedERPtouchlessRate,
    pendingInvoices,
    pendingOutOfSLA,
}: InvoiceReportingCounterProps) {


  return (
    <Display>
      <InvoiceCounterElement label={"Invoice count"} value={invoice_count} warning={false} />
      <Separator />

      {stpRate === undefined ? <CircularProgress /> : <>
        <InvoiceCounterElement
          label={"STP Rate"}
          value={stpRate+'%'}
          warning={false}
        />

        <InvoiceCounterElement
          label={"Touchless invoice rate"}
          value={touchlessInvoiceRate+'%'}
          warning={false}
        />

        <InvoiceCounterElement
          label={"Passed ERP touchless rate"}
          value={passedERPtouchlessRate+'%'}
          warning={false}
        />

        <InvoiceCounterElement
          label={"In-progress"}
          value={pendingInvoices}
          warning={false}
        />
        < Separator />
        <InvoiceCounterElement
          label={"Out of SLA"}
          value={pendingOutOfSLA}
          warning={true}
        /></>
      }
      

    </Display>
  );
}
